<div class="d-flex align-items-center d-md-none">
  @if (showBack) {
    <ds-button
      (click)="back.emit()"
      variant="icon"
      size="s"
      icon="chevronLeft"
      label="Back"
      class="mr-3"
      data-id="back"
    />
  }

  <h3 class="semi-bold">
    @if (title) {
      {{ title }}
    } @else {
      <lead-details-title
        [to]="arrivalAirportCityName"
        [from]="departureAirportCityName"
        [type]="portalLead?.tripType"
      />
    }
  </h3>
</div>

<div class="d-none d-md-flex align-items-center">
  <ds-button
    *ngIf="showBack"
    (click)="back.emit()"
    variant="icon"
    icon="chevronLeft"
    label="Back"
    class="mr-5"
    data-id="back"
  />

  <h1 class="semi-bold">
    @if (title) {
      {{ title }}
    } @else {
      <lead-details-title
        [type]="portalOrder?.tripType"
        [to]="arrivalAirportCityName"
        [from]="departureAirportCityName"
      />
    }
  </h1>
</div>

<lead-details-subtitle
  [departDate]="departureAt ?? '' | date: 'EEE, MMM d'"
  [returnDate]="portalLead?.roundTripDepartureAt ?? '' | date: 'EEE, MMM d'"
  [travelers]="passengerCount"
  [showTripRequestLabel]="!!portalLead"
/>
